module.exports = __webpack_public_path__ + "static/media/gift-1.dd644ca4.svg";